export default "__VITE_ASSET__CSMw5t5K__"